const INBOUND_BASE_URL = process.env.REACT_APP_INBOUND_API_BASE_URL;
const STUCKLISTE_SUPPLIERS = `${INBOUND_BASE_URL}/stuckliste-suppliers`;
const API_DOWNLOAD_STUCKLISTE_SUPPLIERS = `${STUCKLISTE_SUPPLIERS}/download`;

export { STUCKLISTE_SUPPLIERS, API_DOWNLOAD_STUCKLISTE_SUPPLIERS };
